import { RootState } from "@/app/stores"
import { IGetBonusTransactions } from "@/shared/api/bonuses"
import { getCommunityTransactions } from "@/shared/api/community"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchBonusTransactions = createAsyncThunk<
    IGetBonusTransactions,
    void,
    { state: RootState }
>('bonusTransactions/fetchBonusTransactions', async (_, thunkAPI) => {
    try {
        const { page, limit } = thunkAPI.getState().bonusTransactions
        const data = await getCommunityTransactions({
            page,
            limit,
            endDate: new Date(),
            startDate: new Date(0),
        })
        return data.data
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})